import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap"; 
import { Link } from "react-router-dom";
import * as apiUrl from "../../apiUrl";

function CareerDescription() {
  const [CareerDescription, setCareerDescription] = useState([]);

  useEffect(() => {
    const fetchCareerDescription = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/careers/second-section`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setCareerDescription(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchCareerDescription();
  }, []);

  return (
    <section className="latest-blog-sec careers-sec">
      <Container fluid>
        <Row className="flex-center latest-blog-content-row">
          <Col md={6} className="padding-zero">
            <div className="latest-blog-content-div" data-aos="fade-right">
              <h2 className="common-head greyColor">
                {CareerDescription.section_title}
              </h2>
              <p className="common-para">
                {CareerDescription.section_description}
              </p>
              <Link
                to="mailto:hr@marquisdevelopers.com"
                className="marquis-grey-button"
              >
                Apply Now
              </Link>
            </div>
          </Col>
          <Col md={6} className="padding-zero">
            <img
              src={`${apiUrl.apiUrl}/${CareerDescription.section_image}`}
              className="img-fluid"
              alt="Marquis Careers in Dubai"
              data-aos="fade-left"
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default CareerDescription;
